export default {
  methods: {
    clearReportFiltersExceptPeriod(filters) {
      this.conf_cultivo = null;
      this.embalaje = [];
      this.cat_cultivo = [];
      this.conf_embalajes = [];

      return filters.map(filter => {
        if (filter.tipo === "periodo") {
          return filter;
        }

        const resetFilter = {
          ...filter,
          value: filter.tipo === "select_multiple"
            ? []
            : filter.tipo === "text"
              ? ""
              : null
        };

        if (filter.tipo === "select" || filter.tipo === "select_multiple") {
          resetFilter.items = [];
        }

        return resetFilter;
      });
    }
  }
};
